/** src/presentation/components/layout/AppDrawer/AppDrawer.tsx
 * AppDrawer Component
 *
 * Side navigation drawer with user info, navigation links and logout action.
 */

import { Link } from 'react-router-dom';
import { routes } from '@presentation/router';
import type { User } from '@domain/entities';
import styles from './AppDrawer.module.css';

interface AppDrawerProps {
  isOpen: boolean;
  user?: User | null;
  onClose: () => void;
  onLogout: () => void;
}

export function AppDrawer({ isOpen, user, onClose, onLogout }: AppDrawerProps) {
  return (
    <>
      {isOpen && (
        <div
          className={styles.backdrop}
          onClick={onClose}
          role="presentation"
        />
      )}

      <aside className={`${styles.drawer} ${isOpen ? styles.open : ''}`}>
        <div className={styles.userSection}>
          <div className={styles.avatar}>
            {user?.name?.charAt(0).toUpperCase() || 'U'}
          </div>

          <div>
            <h2 className={styles.userName}>{user?.name || 'Usuario'}</h2>
            <p className={styles.userEmail}>{user?.email || ''}</p>
          </div>
        </div>

        <nav className={styles.nav}>
          <Link to={routes.dashboard} className={styles.navLink} onClick={onClose}>
            Incidentes
          </Link>

          <Link to={routes.equipos} className={styles.navLink} onClick={onClose}>
            Equipos
          </Link>
          <Link to={routes.ubicaciones} className={styles.navLink} onClick={onClose}>
            Ubicaciones
          </Link>
          <Link to={routes.visitas} className={styles.navLink} onClick={onClose}>
            Visitas
          </Link>
          <Link to={routes.repuestos} className={styles.navLink} onClick={onClose}>
            Repuestos
          </Link>
        </nav>

        <div className={styles.footer}>
          <button type="button" className={styles.logoutButton} onClick={onLogout}>
            Cerrar sesión
          </button>
        </div>
      </aside>
    </>
  );
}